module.exports = __webpack_public_path__ + "img/hefei.dcde2550.png";